__turbopack_context__.v({
  "feature-comparison": "AcfFeatureComparison-module-scss-module__SpDBuG__feature-comparison",
  "feature-comparison-avatar": "AcfFeatureComparison-module-scss-module__SpDBuG__feature-comparison-avatar",
  "feature-comparison-avatar-container": "AcfFeatureComparison-module-scss-module__SpDBuG__feature-comparison-avatar-container",
  "feature-comparison-avatar-label": "AcfFeatureComparison-module-scss-module__SpDBuG__feature-comparison-avatar-label",
  "feature-comparison-category": "AcfFeatureComparison-module-scss-module__SpDBuG__feature-comparison-category",
  "feature-comparison-heading": "AcfFeatureComparison-module-scss-module__SpDBuG__feature-comparison-heading",
});
